<div class="page-container">
  <ng-container *ngIf="!state.loading; else stateLoading;">
    <ng-container *ngIf="!state.error; else stateError;">
      <div class="row m-left-0 m-right-0">
        <div class="col-player">
          <div class="video-container">
            <div class="video-container-inner">
              <app-vimeo-player [videoURL]="video.videoUrl" [isMarkedWatched]="video.watched" (videoMarkedWatched)="automaticallyMarkVideoWatched()"></app-vimeo-player>
            </div>
          </div>
        </div>
        <div class="col-metadata">
          <div class="card">
            <div class="video-metadata">
              <div class="container-title-watched">
                <div class="video-title">{{video.title}}</div>
    
                <div class="pill-watch-state">
                  <ng-container *ngIf="video.watched; else videoNotWatched;">
                    <span class="watched-pill-hover" (click)="manuallyMarkVideoNotWatched()">
                      <span class="watched-pill-default">
                        <app-pill [type]="ePillType.GREEN">
                          <span class="fal fa-fw fa-check"></span>
                          <strong>WATCHED</strong>
                        </app-pill>
                      </span>
                      <span class="watched-pill-hover">
                        <app-pill [type]="ePillType.RED">
                          <span class="fal fa-fw fa-times"></span>
                          <strong>MARK UNWATCHED</strong>
                        </app-pill>
                      </span>
                    </span>
                  </ng-container>
                  <ng-template #videoNotWatched>
                    <span class="watched-pill-hover" (click)="manuallyMarkVideoWatched()">
                      <span class="watched-pill-default">
                        <app-pill [type]="ePillType.YELLOW">
                          <span class="fal fa-fw fa-sparkles"></span>
                          <strong>NEW</strong>
                        </app-pill>
                      </span>
                      <span class="watched-pill-hover">
                        <app-pill [type]="ePillType.GREEN">
                          <span class="fal fa-fw fa-check"></span>
                          <strong>MARK WATCHED</strong>
                        </app-pill>
                      </span>
                    </span>
                  </ng-template>
                </div>
              </div>
    
              <div class="video-description">{{video.description}}</div>
    
              <div class="video-features">
                <ng-container *ngFor="let feature of video.features">
                  <div class="pill-container">
                    <app-pill>
                      <strong>{{feature | underscoreToSpace}}</strong>
                    </app-pill>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #stateLoading>
    <div class="card">
      <app-loading-state [showMessage]="false"></app-loading-state>
    </div>
  </ng-template>

  <ng-template #stateError>
    <div class="card">
      <div class="p-top-15 p-bottom-15 text-center">
        <img class="icon-padding new-icon-height" src="/assets/img/Error.svg" />
        <br/>
        <span>An error occurred while loading this video</span>
        <br/>
        <span>{{state.errorMessage}}</span>
        <br/>
        <span class="btn-frankli-round btn-frankli-green m-top-10" [routerLink]="'/dashboard'">
          Back to your dashboard?
        </span>
      </div>
    </div>
  </ng-template>
</div>